import "./overflow-menu.css.js";
const e = {
  modifiers: {
    buttonGroup: "pf-m-button-group",
    iconButtonGroup: "pf-m-icon-button-group"
  },
  overflowMenu: "pf-v6-c-overflow-menu",
  overflowMenuContent: "pf-v6-c-overflow-menu__content",
  overflowMenuControl: "pf-v6-c-overflow-menu__control",
  overflowMenuGroup: "pf-v6-c-overflow-menu__group",
  overflowMenuItem: "pf-v6-c-overflow-menu__item"
};
export {
  e as default
};
